<ng-template #loadingSkeleton>
  <div class="disposition-calendar-container skeleton-state">
    <div class="skeleton-panel">
      <div class="skeleton-pill skeleton-animate"></div>
      <div class="skeleton-title skeleton-animate"></div>
      <div class="skeleton-line skeleton-animate" *ngFor="let _ of skeletonPanelItems"></div>
    </div>
    <div class="skeleton-calendar">
      <div class="skeleton-toolbar">
        <div class="skeleton-chip skeleton-animate" *ngFor="let _ of skeletonToolbarItems"></div>
      </div>
      <div class="skeleton-grid">
        <div class="skeleton-column" *ngFor="let _ of skeletonGridColumns">
          <div class="skeleton-block skeleton-animate" *ngFor="let __ of skeletonGridRows"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<div class="disposition-calendar-container" *ngIf="!isInitialLoading || mode === 'agenda'; else loadingSkeleton">
  <!-- Drag-Bereich für aktuellen Auftrag (nur bei Auftragsverplanung) -->
  <div class="drag-orders-panel" *ngIf="orderData && (calendarMode === 'orders' || calendarMode === 'appointment')">
    <div class="resource-panel-header">
      <h5 class="resource-title">Ressourcen</h5>
      <div class="calendar-mode-switcher">
        <button 
          class="btn btn-sm btn-mode-switch" 
          [class.active]="calendarMode === 'orders'"
          (click)="setCalendarMode('orders')">
          Aufträge
        </button>
        <button 
          class="btn btn-sm btn-mode-switch" 
          [class.active]="calendarMode === 'appointment'"
          (click)="setCalendarMode('appointment')"
          [disabled]="!selectedEventData">
          Termin
        </button>
      </div>
    </div>
    
    <!-- Aufträge Inhalt -->
    <div *ngIf="calendarMode === 'orders'" class="orders-panel-content">
      <div *ngIf="isLoadingPanelLeft" class="panel-loading-overlay">
        <i class="fa fa-spinner fa-spin fa-2x"></i>
        <span>Daten werden geladen...</span>
      </div>
      <!-- Phone / Mobile / E-Mail (wie im Calendar) -->
      <div class="resource-contact-buttons" *ngIf="orderData">
        <button type="button" class="resource-contact-btn"
                [class.disabled]="!orderData?.root_order?.person?.phone"
                [disabled]="!orderData?.root_order?.person?.phone"
                [title]="orderData?.root_order?.person?.phone ? 'Festnetz anrufen' : 'Keine Festnetznummer'"
                (click)="orderData?.root_order?.person?.phone && call(orderData.root_order.person.phone)">
          <i class="fa fa-phone"></i>
        </button>
        <button type="button" class="resource-contact-btn"
                [class.disabled]="!orderData?.root_order?.person?.mobile"
                [disabled]="!orderData?.root_order?.person?.mobile"
                [title]="orderData?.root_order?.person?.mobile ? 'Mobil anrufen' : 'Keine Mobilnummer'"
                (click)="orderData?.root_order?.person?.mobile && call(orderData.root_order.person.mobile)">
          <i class="fa fa-mobile-alt"></i>
        </button>
        <button type="button" class="resource-contact-btn"
                [class.disabled]="!orderData?.root_order?.person?.email"
                [disabled]="!orderData?.root_order?.person?.email"
                [title]="orderData?.root_order?.person?.email ? 'E-Mail senden' : 'Keine E-Mail'"
                (click)="orderData?.root_order?.person?.email && openMail(orderData.id || orderData.root_order?.id, orderData.root_order?.person?.email)">
          <i class="fa fa-envelope"></i>
        </button>
      </div>
      <h6 class="panel-section-title">Aktueller Auftrag</h6>
      <div class="team-order-type-select" *ngIf="!hasExistingAppointments()">
        <label class="select-label">Termintyp:</label>
        <select 
          class="form-control" 
          [ngModel]="selectedTeamOrderType"
          (ngModelChange)="onTeamOrderTypeChange($event)"
          [compareWith]="compareTeamOrderTypeById"
          [disabled]="teamOrderTypes.length === 0"
          id="team-order-type-select">
          <option [ngValue]="null" disabled>Bitte wählen...</option>
          <option *ngFor="let option of teamOrderTypes; trackBy: trackByTeamOrderType" [ngValue]="option">
            {{ option.name || option.label || option.id }}
          </option>
        </select>
        <small class="text-muted" *ngIf="teamOrderTypes.length === 0" style="display: block; margin-top: 5px;">
          Termintypen werden geladen...
        </small>
        <small class="text-info" *ngIf="teamOrderTypes.length > 0 && !selectedTeamOrderType" style="display: block; margin-top: 5px;">
          Bitte wählen Sie einen Termintyp aus
        </small>
        <small class="text-success" *ngIf="selectedTeamOrderType" style="display: block; margin-top: 5px;">
          Ausgewählt: {{ selectedTeamOrderType.name || selectedTeamOrderType.label }}
        </small>
      </div>
      <div class="drag-orders-list">
      <!-- Voll verplant: Hinweis statt Drag-Felder -->
      <div class="order-fully-planned-hint" *ngIf="isOrderFullyPlanned()">
        <i class="fa fa-info-circle"></i>
        <span>Auftrag voll verplant. Bitte klonen Sie den Auftrag, um weitere Termine zu verplanen.</span>
      </div>
      <!-- Drag-Felder je nach Termintyp (1 oder mehrere) -->
      <div
        *ngFor="let slot of getDragSlots(); trackBy: trackByDragSlot"
        class="draggable-order"
        [draggable]="true"
        (dragstart)="onDragStart($event, orderData, slot.typeId)">
        <div class="order-type-row">
          <span class="order-type-dot" [style.background-color]="slot.color || getEffectiveTeamOrderType()?.color || '#999'"></span>
          <span class="order-type-label">{{ slot.label }}</span>
        </div>
        <div class="order-name">
          <span *ngIf="orderData.order_number || orderData.root_order?.order_number" class="mr-1">
            #{{ orderData.order_number || orderData.root_order?.order_number }}
          </span>
          {{ orderData.root_order?.person?.first_name }} {{ orderData.root_order?.person?.last_name }}
        </div>
        <div class="order-details">
          {{ orderData.root_order?.street || orderData.street }},
          {{ orderData.root_order?.postal_code || orderData.postal_code }}
          {{ orderData.root_order?.place || orderData.place }}
        </div>
        <div class="order-duration" *ngIf="orderData.duration && !isReklaOrderData(orderData)">{{ orderData.duration }} min</div>
        
        <!-- Küchen: Skills anzeigen -->
        <div class="order-skills" *ngIf="isKitchenOrderData(orderData) && getKitchenSkillItems(orderData).length > 0">
          <div class="skills-label">Eigenschaften:</div>
          <div class="skills-list">
            <span *ngFor="let skill of getKitchenSkillItems(orderData)" class="skill-badge">
              {{ skill.title }}
            </span>
          </div>
        </div>
        
        <!-- Rekla: order-calc-items anzeigen -->
        <div class="order-calc-items" *ngIf="isReklaOrderData(orderData) && orderData.order_calc && orderData.order_calc.calculation">
          <div *ngFor="let category of orderData.order_calc.calculation">
            <div *ngFor="let item of category.items" class="calc-item">
              {{ item.amount }} x {{ item.name }}
            </div>
          </div>
        </div>
      </div>
      
      <!-- Bestehende Termine -->
      <div class="existing-appointments" *ngIf="existingAppointments.length > 0">
        <h6 class="appointments-header">Bestehende Termine</h6>
        <div 
          class="appointment-item" 
          *ngFor="let appointment of existingAppointments"
          [attr.data-appointment-id]="appointment.id"
          (click)="onAppointmentClick(appointment)"
          [class.appointment-selected]="highlightedAppointment?.id === appointment.id">
          <div class="appointment-reserved" *ngIf="appointment.reserved">
            <span class="reserved-badge">reserviert</span>
          </div>
          <div class="appointment-type">
            <span class="appointment-type-dot" [style.background-color]="appointment.teamOrderType?.color || '#999'"></span>
            <span class="appointment-type-text">
              {{ getAppointmentTypeName(appointment.teamOrderType) }}
            </span>
          </div>
          <div class="appointment-date">{{ appointment.start.format('DD.MM.YYYY') }}</div>
          <div class="appointment-time">
            {{ appointment.start.format('HH:mm') }} - {{ appointment.end.format('HH:mm') }} Uhr
            <div class="appointment-team">{{ getTeamName(appointment.teamBase) }}</div>
          </div>
          <div class="appointment-confirmation" *ngIf="getEventConfirmationStatus(appointment) as status">
            <span class="event-confirmation-badge event-confirmation-confirmed" *ngIf="status.label === 'Bestätigt'" [title]="'Bestätigt am ' + status.dateFormatted"><i class="fa fa-check-circle"></i> Bestätigt</span>
            <span class="event-confirmation-badge event-confirmation-declined" *ngIf="status.label === 'nicht bestätigt'" [title]="'nicht bestätigt am ' + status.dateFormatted"><i class="fa fa-times-circle"></i> nicht bestätigt</span>
            <span class="event-confirmation-badge event-confirmation-pending" *ngIf="status.label === 'Wartend'" title="Terminanfrage gesendet – Rückmeldung ausstehend"><i class="fa fa-clock-o"></i> Wartend</span>
          </div>
          <div class="appointment-order-info" *ngIf="appointment.order">
            <div class="appointment-calc-total" *ngIf="appointment.order.order_calcs_total">
              <i class="fa fa-euro-sign"></i> {{ appointment.order.order_calcs_total }}
            </div>
            <div class="appointment-calc-goods" *ngIf="appointment.order.order_goods_total">
              <i class="fa fa-cube"></i> {{ appointment.order.order_goods_total }} m³
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    
    <!-- Termin Inhalt -->
    <div *ngIf="calendarMode === 'appointment'" class="appointment-details-container">
      <!-- Skeleton Loading für linke Seite -->
      <div *ngIf="isLoadingEventData" class="event-skeleton-container">
        <div class="event-skeleton-item skeleton-animate" *ngFor="let _ of [1,2,3,4]"></div>
      </div>
      
      <div *ngIf="!isLoadingEventData && selectedEventData">
        <h6 class="panel-section-title">Termin-Details</h6>
        <div class="event-info-card">
        <!-- Status (volle Breite): Name (label) und Farbe -->
        <div class="event-info-section" *ngIf="selectedEventData.order && (getOrderStatusDisplayLabel(selectedEventData.order) || selectedEventData.order.status_id)">
          <div class="event-status-row-full">
            <span 
              class="event-status-badge-full"
              [style.backgroundColor]="getOrderStatusDisplayColor(selectedEventData.order) || '#6c757d'">
              {{ getOrderStatusDisplayLabel(selectedEventData.order) || ('Status ' + selectedEventData.order.status_id) }}
            </span>
          </div>
        </div>
        <!-- Datum & Zeit -->
        <div class="event-info-section">
          <div class="event-info-row" *ngIf="selectedEventData.event">
            <div class="info-label">
              <span>Datum</span>
            </div>
            <div class="info-value">
              {{ selectedEventData.event.date?.format('DD.MM.YYYY') || selectedEventData.event.start?.format('DD.MM.YYYY') || '-' }}
            </div>
          </div>
          <div class="event-info-row" *ngIf="selectedEventData.event">
            <div class="info-label">
              <span>Zeit</span>
            </div>
            <div class="info-value">
              {{ selectedEventData.event.time || (selectedEventData.event.timeStart + ' - ' + selectedEventData.event.timeEnd) || '-' }}
            </div>
          </div>
          <div class="event-info-row" *ngIf="selectedEventData.order?.duration">
            <div class="info-label">
              <span>Dauer</span>
            </div>
            <div class="info-value">
              {{ selectedEventData.order.duration }} min
            </div>
          </div>
        </div>

        <!-- Auftragsinformationen -->
        <div class="event-info-section" *ngIf="selectedEventData.order">
          <div class="section-divider"></div>
          <div class="event-info-row" *ngIf="selectedEventData.order.order_number || selectedEventData.order.root_order?.order_number">
            <div class="info-label">
              <span>Auftrag</span>
            </div>
            <div class="info-value">
              #{{ selectedEventData.order.order_number || selectedEventData.order.root_order?.order_number }}
            </div>
          </div>
          <div class="event-info-row" *ngIf="selectedEventData.order?.order_type">
            <div class="info-label">
              <span>Auftragstyp</span>
            </div>
            <div class="info-value">
              {{ selectedEventData.order.order_type.label || selectedEventData.order.order_type.name || '-' }}
            </div>
          </div>
        </div>

        <!-- Kundeninformationen -->
        <div class="event-info-section" *ngIf="selectedEventData.order?.root_order?.person">
          <div class="section-divider"></div>
          <div class="event-info-row">
            <div class="info-label">
              <span>Kunde</span>
            </div>
            <div class="info-value">
              {{ selectedEventData.order.root_order.person.first_name }} {{ selectedEventData.order.root_order.person.last_name }}
            </div>
          </div>
          <div class="event-info-row">
            <div class="info-label">
              <span>Adresse</span>
            </div>
            <div class="info-value address-value">
              {{ selectedEventData.order.root_order.person.street }},<br>
              {{ selectedEventData.order.root_order.person.postal_code }} {{ selectedEventData.order.root_order.person.place }}
            </div>
          </div>
        </div>

        <!-- Team & Termintyp -->
        <div class="event-info-section">
          <div class="section-divider"></div>
          <div class="event-info-row" *ngIf="selectedEventData.team">
            <div class="info-label">
              <span>Team</span>
            </div>
            <div class="info-value">
              {{ selectedEventData.team.label || selectedEventData.team.name || 'Team ' + selectedEventData.team.id }}
            </div>
          </div>
          <div class="event-info-row" *ngIf="selectedEventData.teamOrderType">
            <div class="info-label">
              <span>Termintyp</span>
            </div>
            <div class="info-value" [style.color]="selectedEventData.teamOrderType.color || '#333'">
              {{ selectedEventData.teamOrderType.name || selectedEventData.teamOrderType.label || '-' }}
            </div>
          </div>
        </div>

        <!-- Termin bestätigt/abgesagt -->
        <div class="event-info-section" *ngIf="getEventConfirmationStatus(selectedEventData.event) as status">
          <div class="section-divider"></div>
          <div class="event-info-row">
            <div class="info-label">
              <span>Rückmeldung</span>
            </div>
            <div class="info-value">
              <span class="event-confirmation-badge event-confirmation-confirmed" *ngIf="status.label === 'Bestätigt'">
                <i class="fa fa-check-circle"></i> Bestätigt am {{ status.dateFormatted }}
              </span>
              <span class="event-confirmation-badge event-confirmation-declined" *ngIf="status.label === 'nicht bestätigt'">
                <i class="fa fa-times-circle"></i> nicht bestätigt am {{ status.dateFormatted }}
              </span>
              <span class="event-confirmation-badge event-confirmation-pending" *ngIf="status.label === 'Wartend'">
                <i class="fa fa-clock-o"></i> Wartend
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Dokumente -->
      <div class="event-info-section" *ngIf="selectedEventData.order">
        <div class="section-divider"></div>
        <h6 class="panel-section-title" style="margin-bottom: 10px;">Dokumente</h6>
        <div *ngIf="isLoadingEventDocuments" class="loading-indicator">
          <span class="text-muted">Lade Dokumente...</span>
        </div>
        <div *ngIf="!isLoadingEventDocuments">
          <div class="document-list" *ngIf="selectedEventDocuments.length > 0">
            <div 
              class="document-item" 
              *ngFor="let doc of selectedEventDocuments"
              (click)="openDocument(doc)"
              [title]="doc.name">
              <i class="fa fa-file" *ngIf="!doc.is_folder"></i>
              <i class="fa fa-folder" *ngIf="doc.is_folder"></i>
              <span>{{ doc.name }}</span>
            </div>
          </div>
          <div class="empty-state" *ngIf="selectedEventDocuments.length === 0">
            <span class="text-muted">Keine Dokumente vorhanden</span>
          </div>
        </div>
      </div>

      <!-- Notizen -->
      <div class="event-info-section" *ngIf="selectedEventData.order">
        <div class="section-divider"></div>
        <h6 class="panel-section-title" style="margin-bottom: 10px;">Notizen</h6>
        <div *ngIf="isLoadingEventNotes" class="loading-indicator">
          <span class="text-muted">Lade Notizen...</span>
        </div>
        <div *ngIf="!isLoadingEventNotes">
          <div class="note-list" *ngIf="selectedEventNotes.length > 0">
            <div class="note-item" *ngFor="let note of selectedEventNotes">
              <div class="note-header">
                <span class="note-user">{{ note.user?.name || 'System' }}</span>
                <span class="note-date">{{ note.created_at | date: 'dd.MM.yyyy HH:mm' }}</span>
              </div>
              <div class="note-content">{{ note.description }}</div>
            </div>
          </div>
          <div class="empty-state" *ngIf="selectedEventNotes.length === 0">
            <span class="text-muted">Keine Notizen vorhanden</span>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>

  <!-- Personal/Fahrzeug-Panel (nur bei Personal/Fahrzeugverplanung) -->
  <div class="drag-orders-panel" *ngIf="calendarMode === 'staff'">
    <div class="resource-panel-header">
      <h5 class="resource-title">Ressourcen</h5>
      <div class="calendar-mode-switcher">
        <button 
          class="btn btn-sm btn-mode-switch" 
          [class.active]="calendarMode === 'orders'"
          (click)="setCalendarMode('orders')">
          Aufträge
        </button>
        <button 
          class="btn btn-sm btn-mode-switch" 
          [class.active]="calendarMode === 'appointment'"
          (click)="setCalendarMode('appointment')"
          [disabled]="!selectedEventData">
          Termin
        </button>
      </div>
    </div>
    <h6 class="panel-section-title">Personal & Fahrzeuge</h6>
    
    <!-- Filter für Personal -->
    <div class="employee-filter">
      <input 
        type="text" 
        class="form-control" 
        placeholder="Personal suchen..."
        [(ngModel)]="employeeFilter"
        (ngModelChange)="filterEmployees()">
    </div>

    <!-- Personal-Liste -->
    <div class="staff-list">
      <h6 class="staff-section-header">Personal</h6>
      <div class="staff-items">
        <div
          class="draggable-staff-item"
          *ngFor="let employee of filteredEmployees"
          [draggable]="true"
          (dragstart)="onEmployeeDragStart($event, employee)"
          [title]="employee.first_name + ' ' + employee.last_name">
          <i class="fa fa-user"></i>
          <span class="staff-name">{{ employee.first_name }} {{ employee.last_name }}</span>
        </div>
      </div>

      <h6 class="staff-section-header">Fahrzeuge</h6>
      <div class="staff-items">
        <div
          class="draggable-staff-item draggable-vehicle"
          *ngFor="let vehicle of vehicles"
          [draggable]="true"
          (dragstart)="onVehicleDragStart($event, vehicle)"
          [title]="vehicle.label || vehicle.license_plate">
          <i class="fa fa-truck"></i>
          <span class="staff-name">{{ vehicle.label || vehicle.license_plate || 'Fahrzeug ' + vehicle.id }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="calendar-main">
  <div class="calendar-header">
    <div class="calendar-navigation">
      <button class="btn btn-outline-secondary" (click)="previousMonth()" title="Ein Monat zurück">
        <i class="fa fa-chevron-left"></i><i class="fa fa-chevron-left"></i>
      </button>
      <div class="date-navigation-group">
        <button class="btn btn-outline-secondary" (click)="previousPeriod()">
          <i class="fa fa-chevron-left"></i>
        </button>
        <h3 class="calendar-title">{{ getFormattedDate() }}</h3>
        <button class="btn btn-outline-secondary" (click)="nextPeriod()">
          <i class="fa fa-chevron-right"></i>
        </button>
      </div>
      <button class="btn btn-outline-secondary" (click)="nextMonth()" title="Ein Monat vor">
        <i class="fa fa-chevron-right"></i><i class="fa fa-chevron-right"></i>
      </button>
      <button class="btn btn-outline-primary" (click)="createNewTeam()" title="Neues Team hinzufügen">
        <i class="fa fa-plus"></i>
      </button>
      <div class="search-filter-container">
        <input 
          type="text" 
          class="form-control search-filter-input" 
          placeholder="Suche nach Name, Auftragsnummer, PLZ..."
          [(ngModel)]="searchFilter"
          (ngModelChange)="onSearchFilterChange()">
        <i class="fa fa-search search-filter-icon"></i>
        <button 
          class="btn btn-sm btn-link search-filter-clear" 
          *ngIf="searchFilter"
          (click)="clearSearchFilter()">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <!-- Kopierter Auftrag Anzeige -->
      <div class="copied-order-display" *ngIf="copiedOrder && copiedOrder.orderData">
        <i class="fa fa-clipboard" style="margin-right: 5px;"></i>
        <span class="copied-order-text">
          <strong>Kopiert:</strong> 
          <span *ngIf="getCopiedOrderNumber()">#{{ getCopiedOrderNumber() }}</span>
          <span *ngIf="getCopiedOrderNumber() && getCopiedOrderName()">, </span>
          <span *ngIf="getCopiedOrderName()">{{ getCopiedOrderName() }}</span>
        </span>
        <button 
          class="btn btn-sm btn-link copied-order-clear" 
          (click)="clearCopiedOrder()"
          title="Kopierten Auftrag löschen">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>
    <div class="calendar-actions">
      <button class="toolbar-btn" [matMenuTriggerFor]="view" *ngIf="calendarViews && calendarViews.length > 0">
        <mat-icon>view_list</mat-icon>
        <span>Ansicht</span>
      </button>
      <mat-menu #view="matMenu">
        <button *ngFor="let cv of calendarViews" mat-menu-item (click)="selectCalendarView(cv.id)">
          <mat-icon>view_week</mat-icon>
          <span>{{ cv.title }}</span>
        </button>
      </mat-menu>
      <button class="btn btn-primary" (click)="goToToday()">Heute</button>
    </div>
  </div>

  <div class="calendar-wrapper" 
       [class.week-view]="viewMode === 'week'"
       [class.display-mode-full]="displayMode === 'full'"
       [class.display-mode-compact]="displayMode === 'compact'"
       [class.display-mode-team]="displayMode === 'team'">
    <!-- Header Row - Fixiert -->
    <div class="calendar-header-row fixed-header">
      <!-- Team Spalte Header -->
      <div class="team-column-header">
        <div class="team-header-label">Teams</div>
      </div>
      <!-- Wochentage Header -->
      <div class="calendar-weekdays">
        <div 
          class="calendar-weekday" 
          [class.holiday]="day.holiday"
          *ngFor="let day of calendarDays; let i = index"
          (contextmenu)="onWeekdayHeaderRightClick(day, $event)">
          <div class="weekday-name-date">
            <span class="weekday-name">{{ weekDays[i] }}</span>
            <span class="weekday-date" *ngIf="viewMode === 'week'">
              {{ getWeekDayLabel(day) }}
            </span>
            <span class="weekday-date" *ngIf="viewMode === 'month'">{{ day.date.format('DD.MM.') }}</span>
          </div>
          <div class="weekday-holiday" *ngIf="day.holiday">
            {{ day.holiday.name }}
            <span class="weekday-holiday-region">
              {{ day.holiday.is_national ? 'Bundesweit' : (day.holiday.federal_state || '') }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Scrollbarer Kalender-Bereich -->
    <div class="calendar-scrollable" [class.week-view]="viewMode === 'week'">
      <!-- Team Rows -->
      <div class="calendar-team-rows">
        <!-- Agenda: Platzhalter wenn noch keine Teams geladen -->
        <div class="calendar-loading-placeholder" *ngIf="mode === 'agenda' && filteredTeams.length === 0">
          <p>Teams werden geladen…</p>
        </div>
        <div class="calendar-team-row"
             *ngFor="let team of filteredTeams"
             [class.team-row-empty]="viewMode === 'week' && !teamHasEventsThisWeek(team.id)"
             [class.no-events-week]="viewMode === 'week' && !teamHasEventsThisWeek(team.id)">
        <!-- Team Name Spalte -->
        <div class="team-column" 
             (contextmenu)="onTeamColumnRightClick(team, $event)"
             [ngStyle]="{'background-color': (team.team_base?.color || team.color || '#f9f9f9'), 'border-color': (team.team_base?.color || team.color || '#e0e0e0')}">
          <div class="team-name" [ngStyle]="{'color': (team.team_base?.color || team.color) ? '#fff' : '#333'}">{{ team.label || team.name || 'Team ' + team.id }}</div>
          <!-- Team Skills: Klick prüft Teilmenge (Auftrags-Skills vs. Team-Skills), Hover zeigt Popup -->
          <div class="team-skills-btn-wrapper" 
               [title]="getTeamSkillTitles(team)"
               (mouseenter)="showSkillsPopup(team, $event)" 
               (mouseleave)="hideSkillsPopup()">
            <button type="button" class="team-skills-btn" (click)="onTeamSkillsClick(team, $event)">
              <i class="fa fa-tags"></i> Skills
            </button>
          </div>
          <div class="team-weekly-revenue" *ngIf="displayMode !== 'compact' && getTeamWeeklyRevenue(team.id)">
            {{ formatCurrency(getTeamWeeklyRevenue(team.id)) }}
          </div>
          <div class="team-persons" *ngIf="displayMode !== 'compact' && getTeamPersonsCount(team.id) > 0">
            <i class="fa fa-users"></i> {{ getTeamPersonsCount(team.id) }} ({{ getTeamPersonsDays(team.id) }} Tage)
          </div>
          <div class="team-vehicles" *ngIf="displayMode !== 'compact' && getTeamVehiclesCount(team.id) > 0">
            <i class="fa fa-truck"></i> {{ getTeamVehiclesCount(team.id) }} ({{ getTeamVehiclesDays(team.id) }} Tage)
          </div>
        </div>
        
        <!-- Kalendertage für dieses Team -->
        <div class="calendar-days" [class.week-days]="viewMode === 'week'">
            <div
            *ngFor="let day of calendarDays"
            class="calendar-day"
            [class.other-month]="viewMode === 'month' && !day.isCurrentMonth"
            [class.today]="day.isToday"
            [class.selected]="isCellSelected(team.id, day)"
            [class.week-day]="viewMode === 'week'"
            [class.has-holiday]="day.holiday"
            [class.team-blocked]="isTeamBlocked(team.id, day)"
            [class.appointment-highlighted]="isAppointmentHighlighted(team.id, day)"
            [attr.data-appointment-date]="day.date.format('YYYY-MM-DD')"
            [attr.data-team-id]="team.id"
            (click)="selectDate(day, team, $event)"
            (contextmenu)="onDayRightClick(day, team, $event)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (drop)="onDrop($event, team, day)">

            <div class="day-holiday-pill" *ngIf="day.holiday">
              <span class="day-holiday-name">{{ day.holiday.name }}</span>
              <span class="day-holiday-region" *ngIf="!day.holiday.is_national && day.holiday.federal_state">
                ({{ day.holiday.federal_state }})
              </span>
            </div>

            <div class="day-header" *ngIf="viewMode === 'month'">
              <div class="day-events-dots" *ngIf="getEventsForTeamAndDay(team.id, day).length > 0">
                <div
                  class="event-dot"
                  *ngFor="let event of getEventsForTeamAndDay(team.id, day)"
                  [title]="event.title">
                </div>
              </div>
            </div>
            
            <!-- Header für Wochenansicht: Klick öffnet Modal mit Terminliste (team_events) -->
            <div class="day-header-section day-cell-clickable" *ngIf="viewMode === 'week' && (calendarMode === 'orders' || calendarMode === 'appointment')"
                 (click)="selectDate(day, team, $event)"
                 title="Klicken für Terminliste">
              <!-- Team blockiert und GS: auf einer Zeile über dem Strich -->
              <div class="day-info-line" *ngIf="viewMode === 'week' && (!isLoadingEvents || isInitialLoading)">
                <div class="day-blocked-pill" *ngIf="isTeamBlocked(team.id, day)" 
                     [title]="getTeamBlockedNote(team.id, day) || 'Team blockiert'">
                  <i class="fa fa-ban"></i>
                  <span>Team blockiert</span>
                  <span class="blocked-note" *ngIf="getTeamBlockedNote(team.id, day)">
                    {{ getTeamBlockedNote(team.id, day) }}
                  </span>
                </div>
                <div class="rekla-summary" *ngIf="!isLoadingEvents && formatReklaSummary(getReklaSummaryForDay(team.id, day))">
                  {{ formatReklaSummary(getReklaSummaryForDay(team.id, day)) }}
                </div>
              </div>
              <div class="day-header">
                <!-- Personal -->
                <div class="day-team-staffing" *ngIf="getTeamEmployeesForDay(team.id, day).length > 0">
                  {{ getTeamEmployeesForDayFormatted(team.id, day) }}
                </div>
                <!-- Fahrzeuge -->
                <div class="day-team-vehicles" *ngIf="getTeamVehiclesForDay(team.id, day).length > 0">
                  {{ getTeamVehiclesForDayFormatted(team.id, day) }}
                </div>
              </div>
              <div class="day-header-line"></div>
            </div>
            
            <!-- Events für Wochenansicht -->
            <div class="day-events-list" *ngIf="viewMode === 'week'">
              <!-- Skeleton Loading für Events -->
              <div *ngIf="isLoadingEvents && !isInitialLoading" class="event-skeleton-container">
                <div class="event-skeleton-item skeleton-animate" *ngFor="let _ of [1,2,3]"></div>
              </div>
              <ng-container *ngIf="!isLoadingEvents">
                <!-- Kompaktmodus: Kompakte Event-Darstellung -->
                <ng-container *ngIf="displayMode === 'compact'">
                  <div
                    class="event-item-small event-item-compact"
                    *ngFor="let event of getEventsForTeamAndDay(team.id, day)"
                    [class.event-highlighted]="isEventHighlighted(event, team.id, day)"
                    [class.event-draggable]="draggingEvent?.id === event.id"
                    [draggable]="draggingEvent?.id === event.id"
                    [ngStyle]="{
                      'border-left-color': getEventBorderColor(event),
                      'border-left-width': '3px',
                      'background-color': getEventBackgroundColor(event),
                      'color': getEventTextColor(event)
                    }"
                    (click)="onEventClick(event, team, day, $event)"
                    (contextmenu)="onEventRightClick(event, team, day, $event)"
                    (dragstart)="onEventDragStart(event, $event)"
                    [title]="getEventTooltip(event)">
                    <!-- Status oben, volle Breite: status.label + status.color -->
                    <div class="event-card-status-row" *ngIf="getEventOrderStatusDisplay(event)">
                      <span class="event-card-status-badge"
                            [style.backgroundColor]="getEventOrderStatusColor(event) || '#6c757d'">
                        {{ getEventOrderStatusLabel(event) || ('Status ' + (getEventOrderStatusId(event) || '')) }}
                      </span>
                    </div>
                    <!-- Skills vs. Team: Häkchen (Teilmenge) oder Warnzeichen (Auftrag hat Skills außerhalb Team) -->
                    <span class="event-skill-check-icon event-skill-check-ok" *ngIf="viewMode === 'week' && orderSkillsSubsetOfTeam(event, team)" title="Auftrags-Skills sind Teilmenge der Team-Skills">
                      <i class="fa fa-check-circle"></i>
                    </span>
                    <span class="event-skill-check-icon event-skill-check-warn" *ngIf="viewMode === 'week' && orderSkillsExceedTeam(event, team)" title="Auftrag hat Skills, die das Team nicht abdeckt">
                      <i class="fa fa-exclamation-circle"></i>
                    </span>
                    <!-- Zeile 1: R (reserviert), Termintyp, Auftragsnummer, Nachname, AP/SYS/IT + Wert -->
                    <div class="event-compact-line1">
                      <span class="event-compact-reserved-badge" *ngIf="event.reserved">R</span><span class="event-compact-comma" *ngIf="event.reserved && getEventTeamOrderTypeShort(event)">,</span>
                      <span class="event-compact-team-order-type" *ngIf="getEventTeamOrderTypeShort(event)">
                        {{ getEventTeamOrderTypeShort(event) }}
                      </span><span class="event-compact-comma" *ngIf="getEventTeamOrderTypeShort(event) && getEventOrderNumbers(event).first">,</span>
                      <span class="event-compact-order-number" *ngIf="getEventOrderNumbers(event).first">
                        #{{ getEventOrderNumbers(event).first }}
                        <span class="event-compact-order-count-badge" *ngIf="getEventOrderNumbers(event).count > 1">
                          (+{{ getEventOrderNumbers(event).count - 1 }})
                        </span>
                      </span><span class="event-compact-comma" *ngIf="getEventOrderNumbers(event).first && getEventCustomerLastName(event)">,</span>
                      <span class="event-compact-name">{{ getEventCustomerLastName(event) }}</span>
                      <!-- Rekla-Werte: AP, SYS, IT + Wert -->
                      <span *ngIf="isReklaOrder(event) && getReklaSelectedTypeLabel(event)" class="event-compact-rekla-value">
                        <span class="event-compact-comma" *ngIf="getEventCustomerLastName(event)">,</span> {{ getReklaSelectedTypeLabel(event) }}: {{ getReklaSelectedDisplay(event) }}
                      </span>
                      <!-- Dokumente und Bilder in Kompaktansicht -->
                      <span class="event-compact-comma" *ngIf="(getEventDocumentsCount(event) > 0 || getEventImagesCount(event) > 0) && (getEventCustomerLastName(event) || isReklaOrder(event))">,</span>
                      <span class="event-compact-documents" *ngIf="getEventDocumentsCount(event) > 0" [title]="getEventDocumentsCount(event) + ' Dokument(e)'">
                        <i class="fa fa-file"></i><span class="event-compact-count">{{ getEventDocumentsCount(event) }}</span>
                      </span>
                      <span class="event-compact-images" *ngIf="getEventImagesCount(event) > 0" [title]="getEventImagesCount(event) + ' Bild(er)'">
                        <i class="fa fa-image"></i><span class="event-compact-count">{{ getEventImagesCount(event) }}</span>
                      </span>
                    </div>
                    <!-- Zeile 2: PLZ und Ort (bei Küchen auch gleich formatiert) -->
                    <div class="event-compact-line2" *ngIf="getEventPostalCode(event)">
                      <span class="event-compact-postal-code-place">
                        {{ getEventPostalCode(event) }}<span *ngIf="getEventPlace(event)"> {{ getEventPlace(event) }}</span>
                      </span>
                    </div>
                    <!-- Zeile 3: Warenwert, ME, Zeit (bei Küchen; Skills stehen unter Kommentar) -->
                    <div class="event-compact-line3" *ngIf="isKitchenOrder(event) && (getKitchenOrderValue(event) !== null || getKitchenAmountTotal(event) !== null || getKitchenMeHours(event) !== null)">
                      <span class="event-compact-kitchen-value">
                        <span *ngIf="getKitchenOrderValue(event) !== null" class="event-compact-kitchen-warenwert">
                          {{ getKitchenOrderValue(event) | number:'1.2-2' }}
                        </span>
                        <span class="event-compact-comma" *ngIf="getKitchenOrderValue(event) !== null && getKitchenAmountTotal(event) !== null">,</span>
                        <span *ngIf="getKitchenAmountTotal(event) !== null" class="event-compact-kitchen-me">
                          {{ getKitchenAmountTotal(event) }} ME
                          <span *ngIf="getKitchenMeValue(event) !== null">({{ getKitchenMeValue(event) | number:'1.2-2' }} EUR)</span>
                        </span>
                        <span class="event-compact-comma" *ngIf="getKitchenAmountTotal(event) !== null && getKitchenMeHours(event) !== null">,</span>
                        <span *ngIf="getKitchenMeHours(event) !== null" class="event-compact-kitchen-hours">{{ getKitchenMeHours(event) | number:'1.2-2' }}h</span>
                      </span>
                    </div>
                    <!-- Zeile 4: Kommentar -->
                    <div class="event-compact-line4" *ngIf="event.comment">
                      <span class="event-compact-comment">{{ event.comment }}</span>
                    </div>
                    <!-- Zeile 5: Skills bei Küchen (unter Kommentar) -->
                    <div class="event-compact-line5 event-compact-skills-under-comment" *ngIf="isKitchenOrder(event) && getKitchenSkillItems(event.data || event.order || event).length > 0">
                      <span class="event-compact-skills-label">Eigenschaften:</span>
                      <span *ngFor="let skill of getKitchenSkillItems(event.data || event.order || event); let last = last" class="event-compact-skill-badge"
                            [style.background-color]="skill.color || '#6c757d'">{{ skill.title }}<span class="event-compact-comma" *ngIf="!last">,</span></span>
                    </div>
                    <!-- Termin bestätigt/abgesagt (Kompakt) -->
                    <div class="event-compact-confirmation" *ngIf="getEventConfirmationStatus(event) as status">
                      <span class="event-confirmation-badge event-confirmation-confirmed" *ngIf="status.label === 'Bestätigt'"><i class="fa fa-check-circle"></i> Bestätigt</span>
                      <span class="event-confirmation-badge event-confirmation-declined" *ngIf="status.label === 'nicht bestätigt'"><i class="fa fa-times-circle"></i> nicht bestätigt</span>
                      <span class="event-confirmation-badge event-confirmation-pending" *ngIf="status.label === 'Wartend'"><i class="fa fa-clock-o"></i> Wartend</span>
                    </div>
                  </div>
                </ng-container>
                
                <!-- Normalmodus: Standard Event-Darstellung -->
                <ng-container *ngIf="displayMode !== 'compact'">
                  <div
                    class="event-item-small"
                    *ngFor="let event of getEventsForTeamAndDay(team.id, day)"
                [class.event-highlighted]="isEventHighlighted(event, team.id, day)"
                [class.event-draggable]="draggingEvent?.id === event.id"
                [draggable]="draggingEvent?.id === event.id"
                [ngStyle]="{
                  'border-left-color': getEventBorderColor(event),
                  'border-left-width': '3px',
                  'background-color': getEventBackgroundColor(event),
                  'color': getEventTextColor(event)
                }"
                (click)="onEventClick(event, team, day, $event)"
                (contextmenu)="onEventRightClick(event, team, day, $event)"
                (dragstart)="onEventDragStart(event, $event)"
                [title]="getEventTooltip(event)">
                <!-- Status ganz oben, volle Breite: status.label + status.color -->
                <div class="event-card-status-row" *ngIf="getEventOrderStatusDisplay(event)">
                  <span class="event-card-status-badge"
                        [style.backgroundColor]="getEventOrderStatusColor(event) || '#6c757d'">
                    {{ getEventOrderStatusLabel(event) || ('Status ' + (getEventOrderStatusId(event) || '')) }}
                  </span>
                </div>
                <!-- Termin bestätigt/abgesagt -->
                <div class="event-confirmation-row" *ngIf="getEventConfirmationStatus(event) as status">
                  <span class="event-confirmation-badge event-confirmation-confirmed" *ngIf="status.label === 'Bestätigt'" [title]="'Bestätigt am ' + status.dateFormatted">
                    <i class="fa fa-check-circle"></i> Bestätigt<span *ngIf="status.dateFormatted"> am {{ status.dateFormatted }}</span>
                  </span>
                  <span class="event-confirmation-badge event-confirmation-declined" *ngIf="status.label === 'nicht bestätigt'" [title]="'nicht bestätigt am ' + status.dateFormatted">
                    <i class="fa fa-times-circle"></i> nicht bestätigt<span *ngIf="status.dateFormatted"> am {{ status.dateFormatted }}</span>
                  </span>
                  <span class="event-confirmation-badge event-confirmation-pending" *ngIf="status.label === 'Wartend'" title="Terminanfrage gesendet – Rückmeldung ausstehend">
                    <i class="fa fa-clock-o"></i> Wartend
                  </span>
                </div>
                <!-- Skills vs. Team: Häkchen (Teilmenge) oder Warnzeichen (Auftrag hat Skills außerhalb Team) -->
                <span class="event-skill-check-icon event-skill-check-ok" *ngIf="viewMode === 'week' && orderSkillsSubsetOfTeam(event, team)" title="Auftrags-Skills sind Teilmenge der Team-Skills">
                  <i class="fa fa-check-circle"></i>
                </span>
                <span class="event-skill-check-icon event-skill-check-warn" *ngIf="viewMode === 'week' && orderSkillsExceedTeam(event, team)" title="Auftrag hat Skills, die das Team nicht abdeckt">
                  <i class="fa fa-exclamation-circle"></i>
                </span>
                <!-- order_type.label (team_order_type.short) -->
                <div class="event-order-type-line" *ngIf="getEventOrderTypeLabel(event) || getEventTeamOrderTypeShort(event)">
                  <span class="event-order-type-badge">
                    {{ getEventOrderTypeLabel(event) }}
                    <span *ngIf="getEventTeamOrderTypeShort(event)"> ({{ getEventTeamOrderTypeShort(event) }})</span>
                  </span>
                </div>
                <span class="event-time-small" *ngIf="calendarMode === 'orders' || calendarMode === 'appointment'">
                  {{ event.time || (event.timeStart + ' - ' + event.timeEnd) }}
                  <span class="event-order-number" *ngIf="event.order_number"> ({{ event.order_number }})</span>
                </span>
                <span class="event-title-small">
                  <span class="reserved-badge" *ngIf="event.reserved">reserviert</span>
                  <i class="fa fa-exclamation-triangle double-booking-icon" 
                     *ngIf="calendarMode === 'staff' && (doubleBookedEvents.has(event.id) || event.isDoubleBooked)"
                     title="Doppelbelegung"></i>
                  <!-- Dokumente, Bilder und Notizen Icons -->
                  <span class="event-documents-icon" *ngIf="getEventDocumentsCount(event) > 0" 
                        [title]="getEventDocumentsCount(event) + ' Dokument(e)'">
                    <i class="fa fa-file"></i>
                    <span class="event-icon-count">{{ getEventDocumentsCount(event) }}</span>
                  </span>
                  <span class="event-images-icon" *ngIf="getEventImagesCount(event) > 0"
                        [title]="getEventImagesCount(event) + ' Bild(er)'">
                    <i class="fa fa-image"></i>
                    <span class="event-icon-count">{{ getEventImagesCount(event) }}</span>
                  </span>
                  <span class="event-notes-icon" *ngIf="(event.notes_count || event.data?.notes_count || event.order?.notes_count) > 0"
                        [title]="(event.notes_count || event.data?.notes_count || event.order?.notes_count) + ' Notiz(en)'">
                    <i class="fa fa-sticky-note"></i>
                    <span class="event-icon-count">{{ event.notes_count || event.data?.notes_count || event.order?.notes_count }}</span>
                  </span>
                  <strong>{{ getEventCustomerLastName(event) }}</strong>
                </span>
                <div class="event-address-small" [class.text-muted-small]="!isKitchenOrder(event)">
                  <!-- 3. Zeile: Postleitzahl und Ort (bei Küchen-Events) -->
                  <span *ngIf="isKitchenOrder(event)" style="color: #333; font-size: 0.85em; font-weight: 500;">
                    {{ getEventPostalCode(event) }} {{ getEventPlace(event) }}
                  </span>
                  <span *ngIf="!isKitchenOrder(event)">
                    {{ getEventPostalCode(event) }}
                  </span>
                </div>
                <div class="event-comment-small text-muted-small" *ngIf="event.comment">
                  {{ event.comment }}
                </div>
                <!-- Küchen: Skills unter Kommentar -->
                <div class="event-kitchen-skills text-muted-small" *ngIf="isKitchenOrder(event) && getKitchenSkillItems(event.data || event.order || event).length > 0" style="margin-top: 2px; text-align: left; font-size: 0.85em;">
                  <span class="event-kitchen-skills-label">Eigenschaften:</span>
                  <span *ngFor="let skill of getKitchenSkillItems(event.data || event.order || event); let last = last" class="event-kitchen-skill-badge" [style.background-color]="skill.color || '#6c757d'">{{ skill.title }}</span>
                </div>
                <!-- Rekla-Werte: SYS, AP oder IST mit Wert -->
                <div class="event-rekla-values text-muted-small" *ngIf="isReklaOrder(event)" style="margin-top: 2px; text-align: left; font-size: 0.85em;">
                  <i class="fa fa-clock" style="font-size: 0.85em; margin-right: 3px;"></i>
                  <span *ngIf="getReklaSelectedTypeLabel(event)">
                    {{ getReklaSelectedTypeLabel(event) }}: {{ getReklaSelectedDisplay(event) }}
                  </span>
                  <span *ngIf="!getReklaSelectedTypeLabel(event)" class="text-warning">
                    <i class="fa fa-exclamation-triangle"></i> Kein Typ ausgewählt
                  </span>
                </div>
                <!-- Küche-Werte: WW, ME und Payer -->
                <div class="event-kitchen-values text-muted-small" *ngIf="isKitchenOrder(event)" style="margin-top: 2px; text-align: left; font-size: 0.85em;">
                  <div>
                    <i class="fa fa-exclamation-triangle text-warning" *ngIf="getKitchenOrderValue(event) === null" title="Kein Warenwert hinterlegt"></i>
                    <strong>WW:</strong> {{ getKitchenOrderValue(event) || '-' }} EUR
                  </div>
                  <div>
                    <i class="fa fa-exclamation-triangle text-warning" *ngIf="getKitchenAmountTotal(event) === null" title="Keine Montageeinheiten hinterlegt"></i>
                    <strong>ME:</strong> {{ getKitchenAmountTotal(event) || '-' }} ME
                    <span *ngIf="getKitchenMeValue(event) !== null">({{ getKitchenMeValue(event) }} EUR)</span>
                    <span *ngIf="getKitchenMeHours(event) !== null">{{ getKitchenMeHours(event) | number:'1.2-2' }} h</span>
                  </div>
                  <div *ngIf="getKitchenPayerLabel(event)">
                    <strong>Kosten:</strong> {{ getKitchenPayerLabel(event) }}
                  </div>
                </div>
                </div>
                </ng-container>
                <div class="no-events" *ngIf="getEventsForTeamAndDay(team.id, day).length === 0">
                  <span class="text-muted-small">-</span>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

  <!-- Kontextmenü für Termine -->
  <div 
    class="context-menu" 
    *ngIf="showContextMenu && contextMenuType === 'event'"
    [style.left.px]="contextMenuPosition.x"
    [style.top.px]="contextMenuPosition.y"
    (click)="$event.stopPropagation()">
    <div class="context-menu-item" (click)="editAppointment()">
      <i class="fa fa-edit"></i> Bearbeiten
    </div>
    <div class="context-menu-item" (click)="sendAppointmentRequestEmail()">
      <i class="fa fa-envelope"></i> Terminanfrage per E-Mail
    </div>
    <!-- Termin reservieren / nicht reservieren – vorübergehend ausgeblendet
    <div class="context-menu-item" (click)="reserveAppointment()">
      <i class="fa fa-circle"></i> Reservieren / aufheben
    </div>
    -->
    <div class="context-menu-item" (click)="copyOrder()">
      <i class="fa fa-copy"></i> Auftrag kopieren
    </div>
    <div 
      class="context-menu-item" 
      [class.context-menu-item-disabled]="!canPasteOrder()"
      (click)="canPasteOrder() && pasteOrder()">
      <i class="fa fa-paste"></i> Auftrag einfügen
    </div>
    <div class="context-menu-item" (click)="enableMoveAppointment()">
      <i class="fa fa-arrows-alt"></i> Verschieben
    </div>
    <div class="context-menu-item" (click)="switchToOrder()">
      <i class="fa fa-external-link-alt"></i> Zu Auftrag wechseln
    </div>
    <div class="context-menu-item" (click)="openStatusChangeModal()">
      <i class="fa fa-flag"></i> Status ändern
    </div>
    <div class="context-menu-item context-menu-item-danger" (click)="deleteAppointment()">
      <i class="fa fa-trash"></i> Löschen
    </div>
  </div>

  <!-- Kontextmenü für Tag/Team -->
  <div 
    class="context-menu" 
    *ngIf="showContextMenu && contextMenuType === 'day'"
    [style.left.px]="contextMenuPosition.x"
    [style.top.px]="contextMenuPosition.y"
    (click)="$event.stopPropagation()">
    <div class="context-menu-item" (click)="editDay()">
      <i class="fa fa-edit"></i> Bearbeiten
    </div>
    <div 
      class="context-menu-item" 
      [class.context-menu-item-disabled]="!canPasteOrder()"
      (click)="canPasteOrder() && pasteOrder()">
      <i class="fa fa-paste"></i> Auftrag einfügen
    </div>
    <div class="context-menu-item" (click)="blockDay()">
      <i class="fa fa-ban"></i> {{ isTeamBlocked(contextMenuTeam?.id, contextMenuDay) ? 'Blockieren aufheben' : 'Blockieren' }}
    </div>
  </div>

  <!-- Kontextmenü für Tag/Team im Personal/Fahrzeugmodus -->
  <div 
    class="context-menu" 
    *ngIf="showContextMenu && contextMenuType === 'staff-day'"
    [style.left.px]="contextMenuPosition.x"
    [style.top.px]="contextMenuPosition.y"
    (click)="$event.stopPropagation()">
    <div class="context-menu-item" (click)="expandStaffAssignmentsToWeek()">
      <i class="fa fa-expand"></i> Erweitern auf aktuelle Woche
    </div>
    <div class="context-menu-item" (click)="copyStaffAssignments()">
      <i class="fa fa-copy"></i> Belegung kopieren
    </div>
    <div class="context-menu-item context-menu-item-danger" (click)="deleteStaffAssignments()">
      <i class="fa fa-trash"></i> Belegung löschen
    </div>
    <div 
      class="context-menu-item" 
      [class.context-menu-item-disabled]="!canPasteStaffAssignments()"
      (click)="canPasteStaffAssignments() && pasteStaffAssignments()">
      <i class="fa fa-paste"></i> Belegung einfügen
    </div>
  </div>

  <!-- Kontextmenü für Wochentags-Header -->
  <div 
    class="context-menu" 
    *ngIf="showContextMenu && contextMenuType === 'weekday'"
    [style.left.px]="contextMenuPosition.x"
    [style.top.px]="contextMenuPosition.y"
    (click)="$event.stopPropagation()">
    <div class="context-menu-item" (click)="generateDayPdf()">
      <i class="fa fa-file-pdf"></i> Tages PDF erstellen
    </div>
  </div>

  <!-- Kontextmenü für Team-Spalte -->
  <div 
    class="context-menu" 
    *ngIf="showContextMenu && contextMenuType === 'team-column'"
    [style.left.px]="contextMenuPosition.x"
    [style.top.px]="contextMenuPosition.y"
    (click)="$event.stopPropagation()">
    <div class="context-menu-item" (click)="editTeam()">
      <i class="fa fa-edit"></i> Team bearbeiten
    </div>
    <div class="context-menu-item" (click)="blockTeamForWeek()">
      <i class="fa fa-ban"></i> Team für diese Woche blocken
    </div>
  </div>

  <!-- Kontextmenü für Personal/Fahrzeug-Events im Teammode -->
  <div 
    class="context-menu" 
    *ngIf="showContextMenu && contextMenuType === 'staff-event'"
    [style.left.px]="contextMenuPosition.x"
    [style.top.px]="contextMenuPosition.y"
    (click)="$event.stopPropagation()">
    <div class="context-menu-item context-menu-item-danger" (click)="deleteStaffEvent()">
      <i class="fa fa-trash"></i> {{ contextMenuEvent?.event?.dispoType === 0 ? 'Person löschen' : 'Fahrzeug löschen' }}
    </div>
  </div>

  <!-- Modal: col-8 Google Map, col-4 Terminliste (scrollbar) bei Klick auf Resource/Tag-Zelle -->
  <div class="modal-overlay" *ngIf="showDayMapModal" (click)="closeDayMapModal()" style="z-index: 10000;">
    <div class="modal-content day-map-modal-content" (click)="$event.stopPropagation()" *ngIf="dayMapModalTeam && dayMapModalDay">
      <div class="modal-header">
        <h3>{{ dayMapModalTeam?.label || dayMapModalTeam?.name || 'Team' }} – {{ dayMapModalDay?.date?.format('DD.MM.YYYY') }}</h3>
        <button type="button" class="modal-close" (click)="closeDayMapModal()" title="Schließen">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body day-map-modal-body row">
        <div class="col-8 day-map-col-map">
          <div class="day-map-route-summary">
            <button type="button" class="btn btn-sm btn-primary day-map-route-btn"
              [disabled]="(dayMapCachedCoords?.length || 0) < 2 || dayMapRouteLoading"
              (click)="loadDayMapRoute()">
              <i class="fa" [class.fa-spinner]="dayMapRouteLoading" [class.fa-spin]="dayMapRouteLoading" [class.fa-road]="!dayMapRouteLoading"></i>
              {{ dayMapRouteLoading ? 'Wird berechnet…' : 'Route berechnen' }}
            </button>
            <span *ngIf="dayMapRouteDistance" class="day-map-route-result"><i class="fa fa-road"></i> {{ dayMapRouteDistance }}</span>
            <span *ngIf="dayMapRouteDuration" class="day-map-route-result"><i class="fa fa-clock-o"></i> {{ dayMapRouteDuration }}</span>
          </div>
          <agm-map
            class="day-map-agm"
            [latitude]="dayMapMapLat"
            [longitude]="dayMapMapLng"
            [zoom]="dayMapMapZoom"
            [zoomControl]="true"
            [scrollwheel]="true">
            <agm-polyline
              *ngIf="dayMapRoutePath?.length >= 2"
              [strokeColor]="'#1976d2'"
              [strokeOpacity]="0.8"
              [strokeWeight]="4">
              <agm-polyline-point
                *ngFor="let p of dayMapRoutePath"
                [latitude]="p.lat"
                [longitude]="p.lng">
              </agm-polyline-point>
            </agm-polyline>
            <agm-marker
              *ngFor="let item of dayMapCachedCoords; let i = index"
              [latitude]="item.lat"
              [longitude]="item.lng"
              [label]="getDayMapMarkerLabel(item, i)">
            </agm-marker>
          </agm-map>
        </div>
        <div class="col-4 day-map-col-events">
          <h5 class="day-map-events-title">Termine ({{ dayMapDisplayEvents?.length || 0 }})</h5>
          <div class="day-map-event-list day-map-event-list-scroll" *ngIf="dayMapDisplayEvents?.length > 0"
               cdkDropList [cdkDropListData]="dayMapDisplayEventsList" (cdkDropListDropped)="onDayMapOrderDrop($event)">
            <ng-container *ngFor="let ev of dayMapDisplayEventsList; let i = index">
              <div class="day-map-event-item" [class.day-map-event-item-branch-start]="ev.isBranchStart"
                   cdkDrag [cdkDragDisabled]="ev.isBranchStart">
                <span class="day-map-event-drag-handle" *ngIf="!ev.isBranchStart" cdkDragHandle title="Reihenfolge ändern"><i class="fa fa-bars"></i></span>
                <div class="day-map-event-item-main" [class.day-map-event-item-main-clickable]="getDayMapEventLat(ev) != null && getDayMapEventLng(ev) != null" (click)="centerMapOnEvent(ev)">
                  <span class="day-map-event-coords-ok" *ngIf="getDayMapEventLat(ev) != null && getDayMapEventLng(ev) != null" title="Koordinaten vorhanden"><i class="fa fa-check"></i></span>
                  <span class="day-map-event-num">{{ i + 1 }}.</span>
                  <span class="day-map-event-time">{{ getDayMapEventTime(ev) }}</span>
                  <span class="day-map-event-title">{{ getDayMapEventTitle(ev) }}</span>
                  <span class="day-map-event-order-number text-muted" *ngIf="!ev.isBranchStart && getDayMapEventOrderNumber(ev)">Kaufvertrag: {{ getDayMapEventOrderNumber(ev) }}</span>
                  <div class="day-map-event-meta" *ngIf="!ev.isBranchStart">
                    <span class="day-map-event-status badge" *ngIf="getEventOrderStatusLabel(ev)"
                          [style.background-color]="getEventOrderStatusColor(ev) || '#6c757d'">{{ getEventOrderStatusLabel(ev) }}</span>
                    <span class="day-map-event-order-type badge badge-secondary" *ngIf="getEventOrderTypeLabel(ev)">{{ getEventOrderTypeLabel(ev) }}</span>
                    <span class="day-map-event-term-type badge badge-info" *ngIf="getDayMapEventTermTypeLabel(ev)">{{ getDayMapEventTermTypeLabel(ev) }}</span>
                  </div>
                  <span class="day-map-event-address text-muted" *ngIf="getDayMapEventAddress(ev)">{{ getDayMapEventAddress(ev) }}</span>
                </div>
                <div class="day-map-event-item-menu-wrap" *ngIf="!ev.isBranchStart || getDayMapEventLat(ev) == null || getDayMapEventLng(ev) == null">
                  <button type="button" class="day-map-event-menu-btn" (click)="toggleDayMapEventMenu(ev, $event)" title="Menü">
                    <i class="fa fa-ellipsis-v"></i>
                  </button>
                  <div class="day-map-event-dropdown" *ngIf="dayMapMenuOpenForEventId === getDayMapEventMenuId(ev)" (click)="$event.stopPropagation()">
                    <div class="day-map-event-dropdown-item" *ngIf="dayMapGeocodeEventId !== getDayMapEventMenuId(ev)" (click)="requestGeocodeCoords(ev)">
                      <i class="fa fa-map-marker-alt"></i> Koordinate ermitteln
                    </div>
                    <div class="day-map-event-dropdown-item day-map-event-dropdown-item-disabled" *ngIf="dayMapGeocodeEventId === getDayMapEventMenuId(ev)">
                      <i class="fa fa-spinner fa-spin"></i> Wird ermittelt…
                    </div>
                  </div>
                </div>
              </div>
              <div class="day-map-event-segment" *ngIf="i < dayMapDisplayEventsList.length - 1 && dayMapRouteLegs[i]">
                <span class="day-map-event-segment-line" aria-hidden="true"></span>
                <span class="day-map-event-segment-text">
                  <i class="fa fa-road" aria-hidden="true"></i> {{ dayMapRouteLegs[i].distance_text }}
                  <span class="day-map-event-segment-sep">·</span>
                  <i class="fa fa-clock-o" aria-hidden="true"></i> {{ dayMapRouteLegs[i].duration_text }}
                </span>
                <span class="day-map-event-segment-line" aria-hidden="true"></span>
              </div>
            </ng-container>
          </div>
          <p class="text-muted mb-0" *ngIf="!dayMapDisplayEventsList?.length">Keine Termine an diesem Tag.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal für Terminbearbeitung -->
  <div class="modal-overlay" *ngIf="showEditModal" (click)="closeEditModal()">
    <div class="modal-content" (click)="$event.stopPropagation()" *ngIf="editModalData">
      <div class="modal-header">
        <h3>Termin bearbeiten</h3>
        <button class="modal-close" (click)="closeEditModal()">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="modal-section">
          <h4>Zeit</h4>
          <div class="time-input-group">
            <div class="time-input">
              <label>Von:</label>
              <input 
                type="time" 
                [(ngModel)]="editModalData.timeStart" 
                class="form-control">
            </div>
            <div class="time-input">
              <label>Bis:</label>
              <input 
                type="time" 
                [(ngModel)]="editModalData.timeEnd" 
                class="form-control">
            </div>
          </div>
        </div>
        
        <div class="modal-section">
          <h4>Besetzung</h4>
          <div class="staffing-section">
            <div class="staffing-row" *ngIf="editModalData.employees.length > 0 || editModalData.vehicles.length > 0">
              <div class="staffing-group" *ngIf="editModalData.employees.length > 0">
                <label>Personal:</label>
                <div class="staffing-list">
                  <div class="staffing-item" *ngFor="let employee of editModalData.employees">
                    <i class="fa fa-user"></i>
                    <span>{{ employee.displayName || employee.label || employee.title || 'Unbekannt' }}</span>
                  </div>
                </div>
              </div>
              <div class="staffing-group" *ngIf="editModalData.vehicles.length > 0">
                <label>Fahrzeuge:</label>
                <div class="staffing-list">
                  <div class="staffing-item" *ngFor="let vehicle of editModalData.vehicles">
                    <i class="fa fa-truck"></i>
                    <span>{{ vehicle.displayName || vehicle.label || vehicle.title || 'Unbekannt' }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="staffing-empty" *ngIf="editModalData.employees.length === 0 && editModalData.vehicles.length === 0">
              <p class="text-muted">Keine Besetzung für diesen Tag</p>
            </div>
          </div>
        </div>
        
        <div class="modal-section" *ngIf="editModalData.event.data">
          <h4>Auftragsinformationen</h4>
          <div class="order-info">
            <p><strong>Auftrag:</strong> {{ editModalData.event.title || (editModalData.event.data.first_name + ' ' + editModalData.event.data.last_name) }}</p>
            <p *ngIf="editModalData.event.order_number"><strong>Auftragsnummer:</strong> {{ editModalData.event.order_number }}</p>
            <p *ngIf="editModalData.event.data.postal_code"><strong>PLZ:</strong> {{ editModalData.event.data.postal_code }}</p>
            <p *ngIf="editModalData.createdBy"><strong>Angelegt von:</strong> {{ editModalData.createdBy }}</p>
          </div>
        </div>

        <div class="modal-section" *ngIf="getEventConfirmationStatus(editModalData.event) as status">
          <h4>Rückmeldung Kunde</h4>
          <div class="order-info confirmation-info">
            <p class="event-confirmation-badge event-confirmation-confirmed" *ngIf="status.label === 'Bestätigt'">
              <i class="fa fa-check-circle"></i> Der Kunde hat den Termin bestätigt am {{ status.dateFormatted }}
            </p>
            <p class="event-confirmation-badge event-confirmation-declined" *ngIf="status.label === 'nicht bestätigt'">
              <i class="fa fa-times-circle"></i> Der Kunde hat den Termin nicht bestätigt am {{ status.dateFormatted }}
            </p>
            <p class="event-confirmation-badge event-confirmation-pending" *ngIf="status.label === 'Wartend'">
              <i class="fa fa-clock-o"></i> Terminanfrage gesendet – Rückmeldung ausstehend
            </p>
          </div>
        </div>

        <div class="modal-section" *ngIf="editModalData.orderId && statusList?.length">
          <h4>Auftragsstatus</h4>
          <label for="editStatus">Status</label>
          <select
            id="editStatus"
            class="form-control"
            [(ngModel)]="editModalData.statusId">
            <option [ngValue]="null">– Kein Status –</option>
            <option *ngFor="let s of statusList" [ngValue]="s.id">{{ s.label || s.name }}</option>
          </select>
        </div>

        <div class="modal-section">
          <h4>Kommentar</h4>
          <textarea
            class="form-control"
            rows="3"
            [(ngModel)]="editModalData.comment"
            placeholder="Kommentar zum Termin eingeben...">
          </textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeEditModal()">Abbrechen</button>
        <!-- Reserviert-Checkbox im Termin bearbeiten – vorübergehend ausgeblendet
        <div class="form-check" style="margin-right: auto;">
          <input type="checkbox" class="form-check-input" id="editReservation"
                 [(ngModel)]="editModalData.event.reserved"
                 (change)="reserveAppointment(editModalData.event)">
          <label class="form-check-label" for="editReservation">Reserviert</label>
        </div>
        -->
        <button class="btn btn-primary" (click)="saveAppointment()">Speichern</button>
      </div>
    </div>
  </div>

  <!-- Team-Bearbeitungs-Modal -->
  <div class="modal-overlay" *ngIf="showEditTeamModal" (click)="closeEditTeamModal()">
    <div class="modal-content team-edit-modal" (click)="$event.stopPropagation()" *ngIf="editTeamModalData">
      <div class="modal-header">
        <h3>{{ editTeamModalData?.id ? 'Team bearbeiten' : 'Neues Team anlegen' }}</h3>
        <button class="modal-close" (click)="closeEditTeamModal()">
          <i class="fa fa-times"></i>
        </button>
      </div>
      <div class="modal-body team-edit-modal-body">
        <div class="team-edit-tabs">
          <button class="tab-btn" [class.active]="teamEditTab === 'stammdaten'" (click)="teamEditTab = 'stammdaten'">Stammdaten</button>
          <button class="tab-btn" [class.active]="teamEditTab === 'einsatzbereich'" (click)="teamEditTab = 'einsatzbereich'">Einsatzbereich</button>
          <button class="tab-btn" [class.active]="teamEditTab === 'absences'" (click)="teamEditTab = 'absences'; loadTeamAbsencesForTeam(editTeamModalData?.id, teamAbsenceYear)">Abwesenheit</button>
        </div>

        <ng-container *ngIf="teamEditTab === 'stammdaten'">
          <div class="form-grid">
            <div class="form-group">
              <label>Team-Name:</label>
              <input 
                type="text" 
                [(ngModel)]="editTeamModalData.label" 
                class="form-control"
                placeholder="Team-Name">
            </div>
            
            <div class="form-group">
              <label>Farbe:</label>
              <input 
                type="color" 
                [(ngModel)]="editTeamModalData.color" 
                class="form-control color-input">
            </div>
          </div>
          
          <div class="form-grid">
            <div class="form-group">
              <label>Typ:</label>
              <select 
                [(ngModel)]="editTeamModalData.type" 
                class="form-control">
                <option value="">Bitte wählen...</option>
                <option value="K">K - Küche</option>
                <option value="M">M - Montage</option>
                <option value="S">S - Sonstiges</option>
              </select>
            </div>
            
            <div class="form-group">
              <label>Identität:</label>
              <input 
                type="text" 
                [(ngModel)]="editTeamModalData.identity" 
                class="form-control"
                placeholder="Identität">
            </div>
          </div>
          
          <div class="form-grid">
            <div class="form-group">
              <label>Telefon:</label>
              <input 
                type="text" 
                [(ngModel)]="editTeamModalData.phone" 
                class="form-control"
                placeholder="Telefon">
            </div>
            
            <div class="form-group">
              <label>Status-ID:</label>
              <input 
                type="number" 
                [(ngModel)]="editTeamModalData.status_id" 
                class="form-control"
                placeholder="Status-ID">
            </div>
          </div>
          
          <div class="form-grid">
            <div class="form-group">
              <label>Firma:</label>
              <select 
                [(ngModel)]="editTeamModalData.company_id" 
                class="form-control">
                <option [ngValue]="null">Bitte wählen...</option>
                <option *ngFor="let company of companyList" [ngValue]="company.id">
                  {{ company.company_name }}
                </option>
              </select>
            </div>
            
            <div class="form-group">
              <label>Legacy Team-ID:</label>
              <select 
                [(ngModel)]="editTeamModalData.legacy_team_id" 
                class="form-control">
                <option [ngValue]="null">Bitte wählen...</option>
                <option *ngFor="let legacy of legacyList" [ngValue]="legacy.id">
                  {{ legacy.name }} {{ legacy.id }}
                </option>
              </select>
            </div>
          </div>
          
          <div class="form-grid">
            <div class="form-group">
              <label>Standard-Arbeitszeiten:</label>
              <div class="time-input-group">
                <div class="time-input">
                  <input 
                    type="time" 
                    [(ngModel)]="editTeamModalData.default_start" 
                    class="form-control">
                </div>
                <span class="time-separator">-</span>
                <div class="time-input">
                  <input 
                    type="time" 
                    [(ngModel)]="editTeamModalData.default_end" 
                    class="form-control">
                </div>
              </div>
            </div>
          </div>
          
          <div class="form-grid checkbox-row">
            <div class="form-group checkbox-group">
              <label>
                <input 
                  type="checkbox" 
                  [(ngModel)]="editTeamModalData.active" 
                  class="form-check-input">
                <span>Aktiv</span>
              </label>
            </div>
            
            <div class="form-group checkbox-group">
              <label>
                <input 
                  type="checkbox" 
                  [(ngModel)]="editTeamModalData.killable" 
                  class="form-check-input">
                <span>Löschbar</span>
              </label>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="teamEditTab === 'einsatzbereich'">
          <div class="form-grid">
            <div class="form-group">
              <label>Einsatzbereich:</label>
              <select 
                [(ngModel)]="editTeamModalData.area" 
                class="form-control">
                <option value="">Bitte wählen...</option>
                <option value="Nord">Nord</option>
                <option value="Süd">Süd</option>
                <option value="Ost">Ost</option>
                <option value="West">West</option>
                <option value="Mitte">Mitte</option>
                <option value="Bundesweit">Bundesweit</option>
              </select>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="teamEditTab === 'absences'">
          <div class="team-absence-section">
            <div class="absence-header">
              <div class="year-switch">
                <button class="btn btn-sm btn-light" (click)="changeTeamAbsenceYear(-1)"><i class="fa fa-chevron-left"></i></button>
                <span class="year-label">{{ teamAbsenceYear }}</span>
                <button class="btn btn-sm btn-light" (click)="changeTeamAbsenceYear(1)"><i class="fa fa-chevron-right"></i></button>
              </div>
              <span class="text-muted">Abwesenheiten pro Jahr</span>
            </div>
            
            <div *ngIf="isLoadingTeamAbsences" class="loading-indicator">Lade Abwesenheiten...</div>
            
            <div *ngIf="!isLoadingTeamAbsences" class="absence-calendar-container">
              <div *ngIf="teamAbsences.length === 0" class="empty-state">Keine Abwesenheiten</div>
              
              <div class="absence-calendar-grid" *ngIf="absenceCalendarMonths.length > 0">
                <div class="absence-month" *ngFor="let month of absenceCalendarMonths">
                  <h5 class="absence-month-title">{{ month.monthName }}</h5>
                  <div class="absence-calendar-weekdays">
                    <div class="absence-weekday" *ngFor="let weekday of ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So']">
                      {{ weekday }}
                    </div>
                  </div>
                  <div class="absence-calendar-days">
                    <div 
                      class="absence-day"
                      *ngFor="let day of month.days"
                      [class.absence-day-other-month]="!day.isCurrentMonth"
                      [class.absence-day-absent]="day.isAbsent"
                      [class.absence-day-selected]="isAbsenceDaySelected(day.date.format('YYYY-MM-DD'))"
                      [title]="day.isAbsent ? (day.absenceInfo?.absence_type || 'Abwesenheit') + (day.absenceInfo?.note ? ': ' + day.absenceInfo.note : '') : ''"
                      (click)="toggleAbsenceDaySelection(day.date.format('YYYY-MM-DD'), day.isCurrentMonth)">
                      <span class="absence-day-number">{{ day.isCurrentMonth ? day.dayNumber : '' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeEditTeamModal()">Abbrechen</button>
        <button class="btn btn-primary" (click)="saveTeam()">Speichern</button>
      </div>
    </div>
  </div>
</div>

<!-- Modal für Blockierung -->
<div class="modal-overlay" *ngIf="showBlockDayModal" (click)="closeBlockDayModal()">
  <div class="modal-content" (click)="$event.stopPropagation()" *ngIf="showBlockDayModal">
    <div class="modal-header">
      <h3>Team-Tag Blockierung</h3>
      <button class="modal-close" (click)="closeBlockDayModal()">
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="modal-section">
        <div class="form-group" *ngIf="contextMenuTeam">
          <div style="margin-bottom: 12px; font-size: 13px; color: #666;">
            <strong>Team:</strong> {{ contextMenuTeam.label || contextMenuTeam.name || 'Team ' + contextMenuTeam.id }}<br>
            <strong>Datum:</strong> {{ contextMenuDay?.date?.format('DD.MM.YYYY') || '' }}
          </div>
        </div>
        <div class="form-group">
          <label style="display: flex; align-items: center; gap: 8px; cursor: pointer;">
            <input 
              type="checkbox" 
              [(ngModel)]="blockDayModalData.isBlocked"
              style="width: auto; margin: 0;">
            <span>Tag blockieren</span>
          </label>
        </div>
        <div class="form-group" style="margin-top: 16px;">
          <label>Notiz:</label>
          <textarea 
            class="form-control" 
            [(ngModel)]="blockDayModalData.note"
            rows="4"
            placeholder="Notiz zur Blockierung (optional)"></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeBlockDayModal()">Abbrechen</button>
      <button class="btn btn-primary" (click)="saveBlockDay()">Speichern</button>
    </div>
  </div>
</div>

<!-- Modal für Status-Änderung -->
<div class="modal-overlay" *ngIf="showStatusChangeModal" (click)="closeStatusChangeModal()">
  <div class="modal-content" (click)="$event.stopPropagation()" *ngIf="showStatusChangeModal">
    <div class="modal-header">
      <h3>Auftragsstatus ändern</h3>
      <button type="button" class="close" (click)="closeStatusChangeModal()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p *ngIf="statusChangeModalData">
        Auftrag <strong>#{{ statusChangeModalData.orderNumber }}</strong><br>
        <span class="text-muted">Aktuell: {{ statusChangeModalData.currentStatusLabel || '–' }}</span>
      </p>
      <div class="form-group" style="margin-top: 16px;">
        <label>Neuer Status:</label>
        <div class="status-select-list status-select-list-full">
          <button 
            type="button"
            class="btn btn-status-option btn-status-option-full"
            *ngFor="let s of statusList"
            (click)="changeOrderStatusFromModal(s.id)"
            [style.backgroundColor]="s.color || '#6c757d'"
            [class.selected]="statusChangeModalData?.currentStatusId === s.id">
            {{ s.label }}
          </button>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closeStatusChangeModal()">Abbrechen</button>
    </div>
  </div>
</div>

<!-- Modal für Termintyp-Auswahl und Aktion beim Einfügen -->
<div class="modal-overlay" *ngIf="showPasteOrderModal" (click)="closePasteOrderModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Auftrag einfügen</h3>
      <button type="button" class="close" (click)="closePasteOrderModal()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p>Wie soll der Auftrag eingefügt werden?</p>
      
      <!-- Aktion auswählen -->
      <div class="form-group">
        <label>Aktion:</label>
        <div class="radio-group" style="display: flex; flex-direction: column; gap: 10px; margin-top: 10px;">
          <label style="display: flex; align-items: center; cursor: pointer;">
            <input 
              type="radio" 
              name="pasteOrderAction" 
              [value]="'copy'"
              [(ngModel)]="pasteOrderAction"
              style="margin-right: 8px;">
            <span><strong>Kopieren</strong> - Der Termin wird zusätzlich am neuen Standort angelegt (der alte bleibt bestehen)</span>
          </label>
          <label style="display: flex; align-items: center; cursor: pointer;">
            <input 
              type="radio" 
              name="pasteOrderAction" 
              [value]="'move'"
              [(ngModel)]="pasteOrderAction"
              style="margin-right: 8px;">
            <span><strong>Verschieben</strong> - Der zu kopierende Termin wird gelöscht (falls vorhanden) und am neuen Standort angelegt</span>
          </label>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="closePasteOrderModal()">Abbrechen</button>
      <button class="btn btn-primary" (click)="confirmPasteOrder()">
        {{ pasteOrderAction === 'move' ? 'Verschieben' : 'Kopieren' }}
      </button>
    </div>
  </div>
</div>

<!-- Skills-Popup fixed (auf Root-Ebene, immer sichtbar und im Vordergrund) -->
<div class="team-skills-popup team-skills-popup-fixed"
     *ngIf="skillsPopupVisible && skillsPopupTeam"
     [style.left.px]="skillsPopupLeft"
     [style.top.px]="skillsPopupTop"
     (mouseenter)="cancelSkillsPopupHide()"
     (mouseleave)="hideSkillsPopup()">
  <!-- Prüfung Aufträge der Woche (order.params ⊆ team_base.params) -->
  <div class="team-skills-order-check" *ngIf="skillsPopupWeekResult">
    <span class="event-skill-check-ok" *ngIf="skillsPopupWeekResult.withParams > 0 && skillsPopupWeekResult.warn === 0">
      <i class="fa fa-check-circle"></i> {{ skillsPopupWeekResult.withParams }} Aufträge der Woche geprüft: Alle Skills (params) sind Teilmenge von team_base.params
    </span>
    <span class="event-skill-check-warn" *ngIf="skillsPopupWeekResult.warn > 0">
      <i class="fa fa-exclamation-triangle"></i> {{ skillsPopupWeekResult.withParams }} Aufträge geprüft: {{ skillsPopupWeekResult.warn }} mit Skills (params), die das Team nicht abdeckt
    </span>
    <span class="team-skills-week-meta" *ngIf="skillsPopupWeekResult.total === 0">Keine Aufträge dieser Woche dem Team zugeordnet.</span>
    <span class="team-skills-week-meta" *ngIf="skillsPopupWeekResult.total > 0 && skillsPopupWeekResult.withParams === 0">{{ skillsPopupWeekResult.total }} Aufträge der Woche haben keine params.</span>
  </div>
  <div *ngIf="getTeamSkillItems(skillsPopupTeam).length === 0" class="team-skills-empty">Keine Skills hinterlegt</div>
  <div *ngFor="let group of getTeamSkillsByCategory(skillsPopupTeam)" class="team-skills-category">
    <span class="team-skills-category-name">{{ group.categoryName }}</span>
    <div class="team-skills-category-badges">
      <span *ngFor="let skill of group.items"
            class="team-skill-badge"
            [style.background-color]="skill.color || '#6c757d'"
            [style.color]="'#fff'">{{ skill.title || skill.name }}</span>
    </div>
  </div>
</div>

<!-- Router Outlet für Child-Routes (z.B. team/:id/team-base) -->
<router-outlet></router-outlet>
